//DEFAULT CHECKLIST
export const SUCCESS_GET_DEFAULT_CHECKLIST = "SUCCESS_GET_DEFAULT_CHECKLIST";
export const SUCCESS_UPDATE_DEFAULT_CHECKLIST =
  "SUCCESS_UPDATE_DEFAULT_CHECKLIST";

// NEW TYPES
export const SUCCESS_ADD_CHECKLIST = "SUCCESS_ADD_CHECKLIST";
export const ERROR_ADD_CHECKLIST = "ERROR_ADD_CHECKLIST";
export const LOADING_ADD_CHECKLIST = "LOADING_ADD_CHECKLIST";
export const SUCCESS_GET_CHECKLIST = "SUCCESS_GET_CHECKLIST";
export const ERROR_GET_CHECKLIST = "ERROR_GET_CHECKLIST";
export const LOADING_GET_CHECKLIST = "LOADING_GET_CHECKLIST";
export const SUCCESS_UPDATE_CHECKLIST = "SUCCESS_UPDATE_CHECKLIST";
export const ERROR_UPDATE_CHECKLIST = "ERROR_UPDATE_CHECKLIST";
export const LOADING_UPDATE_CHECKLIST = "LOADING_UPDATE_CHECKLIST";
